import React, { Component } from "react";

interface IGameGuideComponent {
    data: {}
}
export const gameGuideComponent: IGameGuideComponent = {
    data: {
        "COMPONENTS": [
            {
                child: [
                    {
                        "id": "gameScrollComponentPortrait",
                        "name": "gameScrollComponentPortrait",
                        "type": "Container",
                        "x": 0,
                        "y": 0,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                        ]
                    },
                    {
                        "id": "gameGuideContentPortrait",
                        "name": "gameGuideContentPortrait",
                        "type": "Container",
                        "x": -100,
                        "y": -200,
                        "visible": true,
                        "filterTypes": [],
                        child: [

                            {
                                "id": "rulesContainer",
                                "name": "rulesContainer",
                                "type": "Container",
                                "x": 200,
                                "y": 349,
                                "visible": true,
                                child: [
                                    {
                                        "id": "Rules_Heading",
                                        "name": "Rules_Heading",
                                        "type": "Text",
                                        "x": 0,
                                        "y": -38,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                        },
                                    },
                                    {
                                        "id": "Rules_Description1",
                                        "name": "Rules_Description1",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 50,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "Rules_Description2",
                                        "name": "Rules_Description2",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 100,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },

                                    {
                                        "id": "Rules_Description2_zs",
                                        "name": "Rules_Description2_zs",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 100,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "Rules_Description3",
                                        "name": "Rules_Description3",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 268,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "Rules_Description3_jp",
                                        "name": "Rules_Description3_jp",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 268,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_2",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "Rules_Description4",
                                        "name": "Rules_Description4",
                                        "type": "Text",
                                        "x": 0,
                                        "y": 390,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_0_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "winWaysContainer",
                                "name": "winWaysContainer",
                                "type": "Container",
                                "x": -750,
                                "y": 577,
                                "visible": true,
                                child: [
                                    {
                                        "id": "WinWays_Heading",
                                        "name": "WinWays_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 251,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description1",
                                        "name": "WinWays_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description1_zs",
                                        "name": "WinWays_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description2",
                                        "name": "WinWays_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 538,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description2_zs",
                                        "name": "WinWays_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 400,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },

                                    {
                                        "id": "WinWays_Description3",
                                        "name": "WinWays_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 655,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description3_zs",
                                        "name": "WinWays_Description3_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 500,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description4",
                                        "name": "WinWays_Description4",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 735,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_1_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "WinWays_Description4_zs",
                                        "name": "WinWays_Description4_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 635,
                                        "width": 530,
                                        "visible": true,
                                        "text": "tag-help-rules_1_3",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },
                            {
                                "id": "tumblesContainer",
                                "name": "tumblesContainer1",
                                "type": "Container",
                                "x": 0,
                                "y": 1180,
                                "visible": true,
                                child: [
                                    {
                                        "id": "tumbles_Heading",
                                        "name": "tumbles_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "tumbles_Heading1",
                                        "name": "tumbles_Heading1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_2_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },

                                    {
                                        "id": "tumbles_Heading1_zs",
                                        "name": "tumbles_Heading1_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 350,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_2_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "tumbles_Heading2",
                                        "name": "tumbles_Heading2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 420,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_2_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "tumbles_Heading3",
                                        "name": "tumbles_Heading3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 500,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_2_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "tumbles_Heading3_zs",
                                        "name": "tumbles_Heading3_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 500,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_2_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "horizontalReelsContainer",
                                "name": "horizontalReelsContainer1",
                                "type": "Container",
                                "x": -750,
                                "y": 1660,
                                "visible": true,
                                child: [
                                    {
                                        "id": "horizontalReels_Heading",
                                        "name": "horizontalReels_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description1",
                                        "name": "horizontalReels_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_3_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description1_jp",
                                        "name": "horizontalReels_Description1_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_3_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description2",
                                        "name": "horizontalReels_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 418,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_3_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description2_jp",
                                        "name": "horizontalReels_Description2_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 418,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_3_1",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "horizontalReels_Description2",
                                        "name": "horizontalReels_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 497,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_3_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "wildsContainer",
                                "name": "wildsContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 1996,
                                "visible": true,
                                child: [
                                    {
                                        "id": "wilds_Heading",
                                        "name": "wilds_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 306,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "wilds_Description1",
                                        "name": "wilds_Description1",
                                        "type": "Text",
                                        "x": 195,
                                        "y": 359,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_4_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "wilds_Description2",
                                        "name": "wilds_Description2",
                                        "type": "Text",
                                        "x": 190,
                                        "y": 400,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_4_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "wilds_Description3",
                                        "name": "wilds_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 480,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_4_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },


                            {
                                "id": "scatterContainer",
                                "name": "scatterContainer2",
                                "type": "Container",
                                "x": -750,
                                "y": 2376,
                                "visible": true,
                                child: [
                                    {
                                        "id": "scatter_Heading",
                                        "name": "scatter_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_5",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "scatter_Description1",
                                        "name": "scatter_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_5_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "scatter_Description1_zs",
                                        "name": "scatter_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_5_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "scatter_Description2",
                                        "name": "scatter_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 420,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_5_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "scatter_Description2_zs",
                                        "name": "scatter_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 420,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_5_1",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "scatter_Description3",
                                        "name": "scatter_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 530,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_5_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },

                                ]
                            },

                            {
                                "id": "randomwildContainer",
                                "name": "randomwildContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 2808,
                                "visible": true,
                                child: [
                                    {
                                        "id": "randomwild_Heading",
                                        "name": "randomwild_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 300,
                                        "visible": true,
                                        "text": "tag-help-rules_6",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "randomwild_Description1",
                                        "name": "randomwild_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_6_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "randomwild_Description1_zs",
                                        "name": "randomwild_Description1_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 700,
                                        "visible": true,
                                        "text": "tag-help-rules_6_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                   
                                ]
                            },

                            {
                                "id": "lockedReelContainer",
                                "name": "lockedReelContainer2",
                                "type": "Container",
                                "x": -750,
                                "y": 3015,
                                "visible": true,
                                child: [
                                    {
                                        "id": "lockedReel_Heading",
                                        "name": "lockedReel_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_7",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description1",
                                        "name": "lockedReel_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 310,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description1_jp",
                                        "name": "lockedReel_Description1_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 310,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description2",
                                        "name": "lockedReel_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 426,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description2_jp",
                                        "name": "lockedReel_Description2_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 426,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description3",
                                        "name": "lockedReel_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 510,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "lockedReel_Description3_jp",
                                        "name": "lockedReel_Description3_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 510,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_7_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "fgmultiplierContainer",
                                "name": "fgmultiplierContainer",
                                "type": "Container",
                                "x": 0,
                                "y": 3396,
                                "visible": true,
                                child: [
                                    {
                                        "id": "fgmultiplier_Heading",
                                        "name": "fgmultiplier_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_8",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description1",
                                        "name": "fgmultiplier_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 290,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_8_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description1_jp",
                                        "name": "fgmultiplier_Description1_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 290,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_8_0",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description2",
                                        "name": "fgmultiplier_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 410,
                                        "width": 2000,
                                        "visible": true,
                                        "text": "tag-help-rules_8_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "fgmultiplier_Description2_jp",
                                        "name": "fgmultiplier_Description2_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 410,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_8_1",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "buyfreespinContainer",
                                "name": "buyfreespinContainer2",
                                "type": "Container",
                                "x": -750,
                                "y": 4581,
                                "visible": true,
                                child: [
                                    {
                                        "id": "buyfreespin_Heading",
                                        "name": "buyfreespin_Heading",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 250,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_9",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description1",
                                        "name": "buyfreespin_Description1",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description1_zs",
                                        "name": "buyfreespin_Description1_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_0",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description2",
                                        "name": "buyfreespin_Description2",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 430,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description2_zs",
                                        "name": "buyfreespin_Description2_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 400,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_1",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description3",
                                        "name": "buyfreespin_Description3",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 550,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description3_zs",
                                        "name": "buyfreespin_Description3_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 510,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_2",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description4",
                                        "name": "buyfreespin_Description4",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 673,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description4_zs",
                                        "name": "buyfreespin_Description4_zs",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 600,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_3",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description5",
                                        "name": "buyfreespin_Description5",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 810,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "buyfreespin_Description5_jp",
                                        "name": "buyfreespin_Description5_jp",
                                        "type": "Text",
                                        "x": 950,
                                        "y": 710,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_9_4",
                                        "scaleToFit":true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },

                            {
                                "id": "additionalContainer",
                                "name": "additionalContainer2",
                                "type": "Container",
                                "x": 0,
                                "y": 3712,
                                "visible": true,
                                child: [
                                    {
                                        "id": "additional_Heading",
                                        "name": "additional_Heading",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 250,
                                        "width": 600,
                                        "visible": true,
                                        "text": "tag-help-rules_10",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#ffffff'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description1",
                                        "name": "additional_Description1",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 300,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_0",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description2",
                                        "name": "additional_Description2",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 380,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_1",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description2_jp",
                                        "name": "additional_Description2_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 380,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_1",
                                        "scaleToFit":false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description3",
                                        "name": "additional_Description3",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 520,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_2",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description4",
                                        "name": "additional_Description4",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 600,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_3",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description4_jp",
                                        "name": "additional_Description4_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 600,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_3",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description5",
                                        "name": "additional_Description5",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 716,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_4",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description5_jp",
                                        "name": "additional_Description5_jp",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 716,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_4",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description6",
                                        "name": "additional_Description6",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 830,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_5",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description6_zs",
                                        "name": "additional_Description6_zs",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 830,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_5",
                                        "scaleToFit": false,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description7",
                                        "name": "additional_Description7",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 990,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_6",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                    {
                                        "id": "additional_Description8",
                                        "name": "additional_Description8",
                                        "type": "Text",
                                        "x": 200,
                                        "y": 1040,
                                        "width": 900,
                                        "visible": true,
                                        "text": "tag-help-rules_10_7",
                                        "scaleToFit": true,
                                        "anchor": [0, 0],
                                        "textStyle": {
                                            fontFamily: 'Oswald-Regular',
                                            fontSize: 35,
                                            fontStyle: 'normal',
                                            fill: ['#848484'],
                                            wordWrap: true,
                                            wordWrapWidth: 900
                                        },
                                    },
                                ]
                            },


                            {
                                "id": "gameControlContent",
                                "name": "gameControlContent",
                                "type": "Container",
                                "x": -100,
                                "y": 5403,
                                "visible": true,
                                "filterTypes": [],
                                child: [
                                    {
                                        "id": "Control_Spin_Container",
                                        "name": "Control_Spin_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 0,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Spin_Heading",
                                                "name": "Spin_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_spin",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 900
                                                },
                                            },
                                            {
                                                "id": "Control_Spin__text",
                                                "name": "Control_Spin__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 700,
                                                "visible": true,
                                                "text": "game-guide_control_body_spin",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "spin_icon",
                                                "image": "spin_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 47,
                                                "height": 45,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },

                                    {
                                        "id": "Control_Bet_Container",
                                        "name": "Control_Bet_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 100,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Bet_Heading",
                                                "name": "Bet_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_stake",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Bet__text",
                                                "name": "Control_Bet__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_stake",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "Bet_icon",
                                                "image": "bet_control_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 33,
                                                "height": 27,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_Menu_Container",
                                        "name": "Control_Menu_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 200,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Menu_Heading",
                                                "name": "Menu_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_menu",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Menu__text",
                                                "name": "Control_Menu__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_menu",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "Menu_icon",
                                                "image": "menu_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 94,
                                                "height": 39,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_Sound_Container",
                                        "name": "Control_Sound_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 300,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Sound_Heading",
                                                "name": "Sound_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_sound",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Sound__text",
                                                "name": "Control_Sound__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_sound",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "Sound_icon",
                                                "image": "sound_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 101,
                                                "height": 32,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_Paytable_Container",
                                        "name": "Control_Paytable_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 400,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Paytable_Heading",
                                                "name": "Paytable_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_paytable",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Paytable__text",
                                                "name": "Control_Paytable__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_paytable",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "Paytable_icon",
                                                "image": "paytable.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 37,
                                                "height": 30,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_BetHistory_Container",
                                        "name": "Control_BetHistory_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 500,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "BetHistory_Heading",
                                                "name": "BetHistory_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_bet-history",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_BetHistory__text",
                                                "name": "Control_BetHistory__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "BetHistory_control_txt",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "BetHistory_icon",
                                                "image": "bet_history_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 42,
                                                "height": 37,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_Settings_Container",
                                        "name": "Control_Settings_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 600,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Settings_Heading",
                                                "name": "Settings_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_settings",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Settings__text",
                                                "name": "Control_Settings__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "Settings_control_txt",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "Settings_icon",
                                                "image": "setting_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 36,
                                                "height": 36,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_GameGuide_Container",
                                        "name": "Control_GameGuide_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 700,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "GameGuide_Heading",
                                                "name": "GameGuide_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_game-guide",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_GameGuide__text",
                                                "name": "Control_GameGuide__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_game-guide",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "GameGuide_icon",
                                                "image": "game_guide_icon.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 29,
                                                "height": 31,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },

                                   
                                    {
                                        "id": "Control_Autoplay_Container",
                                        "name": "Control_Autoplay_Container",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 800,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Autoplay_Heading",
                                                "name": "Autoplay_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_autoplay",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 32,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Autoplay__text",
                                                "name": "Control_Autoplay__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 190,
                                                "width": 900,
                                                "visible": true,
                                                "text": "game-guide_control_body_autoplay",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 28,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 750
                                                },
                                            },
                                            {
                                                "name": "Autoplay_icon",
                                                "image": "autoplay.png",
                                                "type": "Image",
                                                "class": "",
                                                "layout": false,
                                                "uimode": "desktop",
                                                "visible": true,
                                                "width": 161,
                                                "height": 45,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 200,

                                            },


                                        ]
                                    },
                                    {
                                        "id": "Control_Buy_Feature_Portrait",
                                        "name": "Control_Buy_Feature_Portrait",
                                        "type": "Container",
                                        "x": 0,
                                        "y": 900,
                                        "visible": true,
                                        child: [
                                            {
                                                "id": "Buy_Feature_Heading",
                                                "name": "Buy_Feature_Heading",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 150,
                                                "width": 300,
                                                "visible": true,
                                                "text": "game-guide_control_heading_buy-a-feature",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 24,
                                                    fontStyle: 'normal',
                                                    fill: ['#ffffff'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "id": "Control_Buy_Feature__text",
                                                "name": "Control_Buy_Feature__text",
                                                "type": "Text",
                                                "x": 310,
                                                "y": 180,
                                                "width": 700,
                                                "visible": true,
                                                "text": "game-guide_control_body_buy-a-feature",
                                                "scaleToFit": true,
                                                "anchor": [0, 0],
                                                "textStyle": {
                                                    fontFamily: 'Oswald-Regular',
                                                    fontSize: 22,
                                                    fontStyle: 'normal',
                                                    fill: ['#848484'],
                                                    wordWrap: true,
                                                    wordWrapWidth: 800
                                                },
                                            },
                                            {
                                                "name": "buy_now_icon",
                                                "image": "buy_now_icon_updated",
                                                "type": "Image",
                                                "class": "",
                                                /*  "layout": false,
                                                 "uimode": "desktop", */
                                                "visible": true,
                                                "width": 117,
                                                "height": 51,
                                                "anchor": [0.5, 0.5],
                                                "x": 1125,
                                                "y": 190,

                                            },

                                        ]
                                    },
                                ]
                            },

                        ]
                    },
                ]
            },

        ],
    }


};

export const GameGuideComponentPortraitConfigurationContext = React.createContext(
    {}
);